export abstract class MultiSelectorItem {
  public abstract getId(): string;
  public abstract getDisplayText(): string;
  public abstract getDescription(): string;
}
